import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DominioItem } from '@gestor-web/@core/api/ords/model';
import { GeralService } from '@gestor-web/app/shared/services';
import { SelectItem } from 'primeng/api';
import { Popover } from 'primeng/popover';
import { first } from 'rxjs/operators';

export interface RpsPrestadoresRegistradosFilterData {
  idClassificacao: string;
  snUrgenciaEmergencia: string;
  tpRelacaoOperadora: string;
  tpContratualizacao: string;
  nrCpfCnpj: string;
  nrCnes: string;
  nrRegistroPlano: string;
}

export const FILTRO_VAZIO: RpsPrestadoresRegistradosFilterData = {
  idClassificacao: null,
  snUrgenciaEmergencia: null,
  tpRelacaoOperadora: null,
  tpContratualizacao: null,
  nrCpfCnpj: null,
  nrCnes: null,
  nrRegistroPlano: null,
};

export const DOMINIO_CLASSIFICACAO = 'RPS_CLASSIFICACAO_PRESTADOR';
export const DOMINIO_URGENCIA_EMERGENCIA = 'RPS_URGENCIA_EMERGENCIA';
export const DOMINIO_RELACAO_OPERADORA = 'RPS_RELACAO_OPERADORA';
export const DOMINIO_CONTRATUALIZACAO = 'RPS_TIPO_CONTRATUALIZACAO';

// CNPJ, CNES e registro do plano são gravados só com dígitos; a máscara colada pelo usuário não pode ir para o filtro.
const somenteDigitos = (valor: string) => valor?.replace(/\D/g, '') || null;

@Component({
  selector: 'bl-rps-prestadores-registrados-filtro',
  templateUrl: './filtro.component.html',
  styleUrls: ['./filtro.component.scss'],
  standalone: false,
})
export class RpsPrestadoresRegistradosFiltroComponent implements OnInit, OnChanges {
  @ViewChild('filterPanel') filterPanel: Popover;

  @Input() data: RpsPrestadoresRegistradosFilterData;

  @Output() dataChange = new EventEmitter<RpsPrestadoresRegistradosFilterData>();

  classificacaoOptions: SelectItem<string>[] = [];
  urgenciaEmergenciaOptions: SelectItem<string>[] = [];
  relacaoOperadoraOptions: SelectItem<string>[] = [];
  contratualizacaoOptions: SelectItem<string>[] = [];

  count = 0;
  label = '';

  local: RpsPrestadoresRegistradosFilterData = { ...FILTRO_VAZIO };

  constructor(private geralService: GeralService) {}

  ngOnInit(): void {
    this.loadOptions(DOMINIO_CLASSIFICACAO, options => (this.classificacaoOptions = options));
    this.loadOptions(DOMINIO_URGENCIA_EMERGENCIA, options => (this.urgenciaEmergenciaOptions = options));
    this.loadOptions(DOMINIO_RELACAO_OPERADORA, options => (this.relacaoOperadoraOptions = options));
    this.loadOptions(DOMINIO_CONTRATUALIZACAO, options => (this.contratualizacaoOptions = options));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.updateLabel();
    }
  }

  private loadOptions(dominio: string, setter: (options: SelectItem<string>[]) => void) {
    this.geralService
      .getDominioPorTipo(dominio)
      .pipe(first())
      .subscribe((itens: DominioItem[]) =>
        setter(
          itens.map(item => ({
            label: `${item.cd_valor_valido} - ${item.ds_valor_valido}`,
            value: item.cd_valor_valido,
          })),
        ),
      );
  }

  private updateLabel() {
    this.count = Object.values(this.data ?? {}).filter(valor => valor != null).length;
    this.label = this.count === 0 ? '' : this.count + ' filtro' + (this.count > 1 ? 's' : '');
  }

  onShow($event: Event) {
    this.local = { ...FILTRO_VAZIO, ...this.data };
    this.filterPanel.toggle($event);
  }

  onApply() {
    this.data = {
      ...this.local,
      nrCpfCnpj: somenteDigitos(this.local.nrCpfCnpj),
      nrCnes: somenteDigitos(this.local.nrCnes),
      nrRegistroPlano: somenteDigitos(this.local.nrRegistroPlano),
    };
    this.updateLabel();
    this.dataChange.emit(this.data);
    this.filterPanel.hide();
  }

  onClear() {
    this.local = { ...FILTRO_VAZIO };
    this.data = { ...FILTRO_VAZIO };
    this.count = 0;
    this.label = '';
    this.dataChange.emit(this.data);
    this.filterPanel.hide();
  }
}
